import { SubscriptionExpiredBase } from '../base/subscriptionExpiredBase.component';

export class SubscriptionExpired extends SubscriptionExpiredBase {}
